import { render, staticRenderFns } from "./nav_home.vue?vue&type=template&id=12685b3e&"
import script from "./nav_home.vue?vue&type=script&lang=js&"
export * from "./nav_home.vue?vue&type=script&lang=js&"
import style0 from "./nav_home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports